'use client';

import { createContext, useContext, useState, useCallback, type CSSProperties, type ReactNode } from 'react';

interface WeatherBarContextValue {
  visible: boolean;
  setVisible: (v: boolean) => void;
}

const WeatherBarContext = createContext<WeatherBarContextValue>({
  visible: false,
  setVisible: () => {},
});

export function WeatherBarProvider({ children }: { children: ReactNode }) {
  const [visible, setVisibleState] = useState(false);
  const setVisible = useCallback((v: boolean) => setVisibleState(v), []);

  return (
    <WeatherBarContext.Provider value={{ visible, setVisible }}>
      <div className="site-shell" style={{ "--weather-bar-height": visible ? "44px" : "0px" } as CSSProperties}>{children}</div>
    </WeatherBarContext.Provider>
  );
}

export function useWeatherBar() {
  return useContext(WeatherBarContext);
}
